import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const { REACT_APP_API_BASE_URL } = process.env;

const TIME_INFO = '/v1/time_info';


export const generalApi = createApi({
	reducerPath: 'generalApi',
	baseQuery: fetchBaseQuery({
        baseUrl: REACT_APP_API_BASE_URL,
    }),
	endpoints: (builder) => ({
		getYear: builder.query({
            query: () => TIME_INFO,
        }),
	})
});


export const {
    useGetYearQuery,
} = generalApi;
